export var data = {
    'response': {
        'nodes': {
            'Q': {
                'label': 'Q',
                'frequency': {
                    'absolute': 3,
                    'relative': 0,
                    'cases': 3,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'Q',
                'event_type': null
            },
            'W': {
                'label': 'W',
                'frequency': {
                    'absolute': 13,
                    'relative': 0,
                    'cases': 13,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'W',
                'event_type': null
            },
            'E': {
                'label': 'E',
                'frequency': {
                    'absolute': 227,
                    'relative': 0,
                    'cases': 178,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'E',
                'event_type': null
            },
            'R': {
                'label': 'R',
                'frequency': {
                    'absolute': 16,
                    'relative': 0,
                    'cases': 16,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'R',
                'event_type': null
            },
            'T': {
                'label': 'T',
                'frequency': {
                    'absolute': 1,
                    'relative': 0,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'T',
                'event_type': null
            },
            'Y': {
                'label': 'Y',
                'frequency': {
                    'absolute': 6,
                    'relative': 0,
                    'cases': 6,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'Y',
                'event_type': null
            },
            'U': {
                'label': 'U',
                'frequency': {
                    'absolute': 23,
                    'relative': 0,
                    'cases': 22,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'U',
                'event_type': null
            },
            'I': {
                'label': 'I',
                'frequency': {
                    'absolute': 8,
                    'relative': 0,
                    'cases': 8,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'I',
                'event_type': null
            },
            'O': {
                'label': 'O',
                'frequency': {
                    'absolute': 2,
                    'relative': 0,
                    'cases': 2,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'O',
                'event_type': null
            },
            'P': {
                'label': 'P',
                'frequency': {
                    'absolute': 16,
                    'relative': 0,
                    'cases': 16,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'P',
                'event_type': null
            },
            'A': {
                'label': 'A',
                'frequency': {
                    'absolute': 8,
                    'relative': 0,
                    'cases': 8,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'A',
                'event_type': null
            },
            'S': {
                'label': 'S',
                'frequency': {
                    'absolute': 34,
                    'relative': 0,
                    'cases': 34,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'S',
                'event_type': null
            },
            'D': {
                'label': 'D',
                'frequency': {
                    'absolute': 310,
                    'relative': 0,
                    'cases': 152,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'D',
                'event_type': null
            },
            'F': {
                'label': 'F',
                'frequency': {
                    'absolute': 12,
                    'relative': 0,
                    'cases': 12,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'F',
                'event_type': null
            },
            'G': {
                'label': 'G',
                'frequency': {
                    'absolute': 27,
                    'relative': 0,
                    'cases': 27,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'G',
                'event_type': null
            },
            'H': {
                'label': 'H',
                'frequency': {
                    'absolute': 226,
                    'relative': 0,
                    'cases': 225,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'H',
                'event_type': null
            },
            'J': {
                'label': 'J',
                'frequency': {
                    'absolute': 375,
                    'relative': 0,
                    'cases': 226,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'J',
                'event_type': null
            },
            'K': {
                'label': 'K',
                'frequency': {
                    'absolute': 12,
                    'relative': 0,
                    'cases': 12,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'K',
                'event_type': null
            },
            'L': {
                'label': 'L',
                'frequency': {
                    'absolute': 6,
                    'relative': 0,
                    'cases': 6,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'L',
                'event_type': null
            },
            'Z': {
                'label': 'Z',
                'frequency': {
                    'absolute': 0,
                    'relative': 0,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'Z',
                'event_type': null
            },
            'X': {
                'label': 'X',
                'frequency': {
                    'absolute': 4,
                    'relative': 0,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'X',
                'event_type': null
            },
            'C': {
                'label': 'C',
                'frequency': {
                    'absolute': 5,
                    'relative': 0,
                    'cases': 5,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'C',
                'event_type': null
            },
            'V': {
                'label': 'V',
                'frequency': {
                    'absolute': 100,
                    'relative': 0,
                    'cases': 48,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'V',
                'event_type': null
            },
            'B': {
                'label': 'B',
                'frequency': {
                    'absolute': 22,
                    'relative': 0,
                    'cases': 22,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'B',
                'event_type': null
            },
            'N': {
                'label': 'N',
                'frequency': {
                    'absolute': 1,
                    'relative': 0,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'N',
                'event_type': null
            },
            'M': {
                'label': 'M',
                'frequency': {
                    'absolute': 227,
                    'relative': 0,
                    'cases': 226,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'M',
                'event_type': null
            },
            'QQ': {
                'label': 'QQ',
                'frequency': {
                    'absolute': 1,
                    'relative': 0,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'QQ',
                'event_type': null
            },
            'WW': {
                'label': 'WW',
                'frequency': {
                    'absolute': 229,
                    'relative': 0,
                    'cases': 227,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'WW',
                'event_type': null
            },
            'EE': {
                'label': 'EE',
                'frequency': {
                    'absolute': 1,
                    'relative': 0,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'EE',
                'event_type': null
            },
            'RR': {
                'label': 'RR',
                'frequency': {
                    'absolute': 6,
                    'relative': 0,
                    'cases': 6,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'RR',
                'event_type': null
            },
            'TT': {
                'label': 'TT',
                'frequency': {
                    'absolute': 4,
                    'relative': 0,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'TT',
                'event_type': null
            },
            'YY': {
                'label': 'YY',
                'frequency': {
                    'absolute': 60,
                    'relative': 0,
                    'cases': 27,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'YY',
                'event_type': null
            },
            'UU': {
                'label': 'UU',
                'frequency': {
                    'absolute': 3,
                    'relative': 0,
                    'cases': 3,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'UU',
                'event_type': null
            },
            'II': {
                'label': 'II',
                'frequency': {
                    'absolute': 11,
                    'relative': 0,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'II',
                'event_type': null
            },
            'OO': {
                'label': 'OO',
                'frequency': {
                    'absolute': 4,
                    'relative': 0,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'OO',
                'event_type': null
            },
            'PP': {
                'label': 'PP',
                'frequency': {
                    'absolute': 42,
                    'relative': 0,
                    'cases': 42,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 9223372036854776000,
                    'max': -9223372036854776000,
                    'mean': 0,
                    'median': 0
                },
                'event_name': 'PP',
                'event_type': null
            }
        },
        'arcs': {
            'R|V': {
                'source': 'R',
                'target': 'V',
                'frequency': {
                    'absolute': 15,
                    'relative': 0.01020408163265306,
                    'cases': 15,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.9375
            },
            'H|II': {
                'source': 'H',
                'target': 'II',
                'frequency': {
                    'absolute': 3,
                    'relative': 0.0020408163265306124,
                    'cases': 3,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 31622400000,
                    'min': 31622400000,
                    'max': 31622400000,
                    'mean': 10540800000,
                    'median': 0
                },
                'dependency': 0.75
            },
            'W|D': {
                'source': 'W',
                'target': 'D',
                'frequency': {
                    'absolute': 9,
                    'relative': 0.006122448979591836,
                    'cases': 9,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.9
            },
            'YY|M': {
                'source': 'YY',
                'target': 'M',
                'frequency': {
                    'absolute': 5,
                    'relative': 0.003401360544217687,
                    'cases': 5,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 15033600000,
                    'min': 15033600000,
                    'max': 15033600000,
                    'mean': 3006720000,
                    'median': 0
                },
                'dependency': 0.5714285714285714
            },
            'YY|E': {
                'source': 'YY',
                'target': 'E',
                'frequency': {
                    'absolute': 17,
                    'relative': 0.011564625850340135,
                    'cases': 17,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 43372800000,
                    'min': 43372800000,
                    'max': 43372800000,
                    'mean': 2551341176,
                    'median': 0
                },
                'dependency': 0.9444444444444444
            },
            'A|YY': {
                'source': 'A',
                'target': 'YY',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'F|D': {
                'source': 'F',
                'target': 'D',
                'frequency': {
                    'absolute': 2,
                    'relative': 0.0013605442176870747,
                    'cases': 2,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.6666666666666666
            },
            'Y|V': {
                'source': 'Y',
                'target': 'V',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'II|E': {
                'source': 'II',
                'target': 'E',
                'frequency': {
                    'absolute': 2,
                    'relative': 0.0013605442176870747,
                    'cases': 2,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 1468800000,
                    'min': 1468800000,
                    'max': 1468800000,
                    'mean': 734400000,
                    'median': 0
                },
                'dependency': 0.6666666666666666
            },
            'T|D': {
                'source': 'T',
                'target': 'D',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'TT|D': {
                'source': 'TT',
                'target': 'D',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'K|V': {
                'source': 'K',
                'target': 'V',
                'frequency': {
                    'absolute': 11,
                    'relative': 0.007482993197278911,
                    'cases': 11,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.9166666666666666
            },
            'J|H': {
                'source': 'J',
                'target': 'H',
                'frequency': {
                    'absolute': 152,
                    'relative': 0.10340136054421768,
                    'cases': 152,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.9934640522875817
            },
            'D|M': {
                'source': 'D',
                'target': 'M',
                'frequency': {
                    'absolute': 16,
                    'relative': 0.010884353741496598,
                    'cases': 16,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 57456000000,
                    'min': 57456000000,
                    'max': 57456000000,
                    'mean': 3591000000,
                    'median': 0
                },
                'dependency': 0.9411764705882353
            },
            'D|J': {
                'source': 'D',
                'target': 'J',
                'frequency': {
                    'absolute': 6,
                    'relative': 0.004081632653061225,
                    'cases': 6,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 87696000000,
                    'min': 87696000000,
                    'max': 87696000000,
                    'mean': 14616000000,
                    'median': 0
                },
                'dependency': 0.8571428571428571
            },
            'WW|UU': {
                'source': 'WW',
                'target': 'UU',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 1123200000,
                    'min': 1123200000,
                    'max': 1123200000,
                    'mean': 1123200000,
                    'median': 0
                },
                'dependency': 0.5
            },
            'TT|V': {
                'source': 'TT',
                'target': 'V',
                'frequency': {
                    'absolute': 3,
                    'relative': 0.0020408163265306124,
                    'cases': 3,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 13910400000,
                    'min': 13910400000,
                    'max': 13910400000,
                    'mean': 4636800000,
                    'median': 0
                },
                'dependency': 0.75
            },
            'A|J': {
                'source': 'A',
                'target': 'J',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'F|YY': {
                'source': 'F',
                'target': 'YY',
                'frequency': {
                    'absolute': 6,
                    'relative': 0.004081632653061225,
                    'cases': 6,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.8571428571428571
            },
            'EE|D': {
                'source': 'EE',
                'target': 'D',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'B|D': {
                'source': 'B',
                'target': 'D',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'V|V': {
                'source': 'V',
                'target': 'V',
                'frequency': {
                    'absolute': 7,
                    'relative': 0.004761904761904762,
                    'cases': 7,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.875
            },
            'II|II': {
                'source': 'II',
                'target': 'II',
                'frequency': {
                    'absolute': 4,
                    'relative': 0.0027210884353741495,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.8
            },
            'W|V': {
                'source': 'W',
                'target': 'V',
                'frequency': {
                    'absolute': 4,
                    'relative': 0.0027210884353741495,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.8
            },
            'I|D': {
                'source': 'I',
                'target': 'D',
                'frequency': {
                    'absolute': 7,
                    'relative': 0.004761904761904762,
                    'cases': 7,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.875
            },
            'V|J': {
                'source': 'V',
                'target': 'J',
                'frequency': {
                    'absolute': 3,
                    'relative': 0.0020408163265306124,
                    'cases': 3,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 45792000000,
                    'min': 45792000000,
                    'max': 45792000000,
                    'mean': 15264000000,
                    'median': 0
                },
                'dependency': 0.75
            },
            'N|D': {
                'source': 'N',
                'target': 'D',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'B|H': {
                'source': 'B',
                'target': 'H',
                'frequency': {
                    'absolute': 13,
                    'relative': 0.008843537414965987,
                    'cases': 13,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.9285714285714286
            },
            'B|V': {
                'source': 'B',
                'target': 'V',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'H|S': {
                'source': 'H',
                'target': 'S',
                'frequency': {
                    'absolute': 33,
                    'relative': 0.022448979591836733,
                    'cases': 33,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 111196800000,
                    'min': 111196800000,
                    'max': 111196800000,
                    'mean': 3369600000,
                    'median': 0
                },
                'dependency': 0.9705882352941176
            },
            'Q|YY': {
                'source': 'Q',
                'target': 'YY',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'V|M': {
                'source': 'V',
                'target': 'M',
                'frequency': {
                    'absolute': 12,
                    'relative': 0.00816326530612245,
                    'cases': 12,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 54345600000,
                    'min': 54345600000,
                    'max': 54345600000,
                    'mean': 4528800000,
                    'median': 0
                },
                'dependency': 0.7857142857142857
            },
            'H|E': {
                'source': 'H',
                'target': 'E',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 691200000,
                    'min': 691200000,
                    'max': 691200000,
                    'mean': 691200000,
                    'median': 0
                },
                'dependency': 0.5
            },
            'UU|D': {
                'source': 'UU',
                'target': 'D',
                'frequency': {
                    'absolute': 3,
                    'relative': 0.0020408163265306124,
                    'cases': 3,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.75
            },
            'QQ|YY': {
                'source': 'QQ',
                'target': 'YY',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'D|WW': {
                'source': 'D',
                'target': 'WW',
                'frequency': {
                    'absolute': 115,
                    'relative': 0.0782312925170068,
                    'cases': 115,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 293760000000,
                    'min': 293760000000,
                    'max': 293760000000,
                    'mean': 2554434782,
                    'median': 0
                },
                'dependency': 0.9576271186440678
            },
            'M|H': {
                'source': 'M',
                'target': 'H',
                'frequency': {
                    'absolute': 51,
                    'relative': 0.03469387755102041,
                    'cases': 51,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.9807692307692307
            },
            'YY|J': {
                'source': 'YY',
                'target': 'J',
                'frequency': {
                    'absolute': 2,
                    'relative': 0.0013605442176870747,
                    'cases': 2,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 35510400000,
                    'min': 35510400000,
                    'max': 35510400000,
                    'mean': 17755200000,
                    'median': 0
                },
                'dependency': 0.6666666666666666
            },
            'S|E': {
                'source': 'S',
                'target': 'E',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 3024000000,
                    'min': 3024000000,
                    'max': 3024000000,
                    'mean': 3024000000,
                    'median': 0
                },
                'dependency': 0.5
            },
            'E|J': {
                'source': 'E',
                'target': 'J',
                'frequency': {
                    'absolute': 141,
                    'relative': 0.09591836734693877,
                    'cases': 141,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 524793600000,
                    'min': 524793600000,
                    'max': 524793600000,
                    'mean': 3721940425,
                    'median': 0
                },
                'dependency': 0.521505376344086
            },
            'U|H': {
                'source': 'U',
                'target': 'H',
                'frequency': {
                    'absolute': 2,
                    'relative': 0.0013605442176870747,
                    'cases': 2,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.6666666666666666
            },
            'C|YY': {
                'source': 'C',
                'target': 'YY',
                'frequency': {
                    'absolute': 4,
                    'relative': 0.0027210884353741495,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.8
            },
            'PP|D': {
                'source': 'PP',
                'target': 'D',
                'frequency': {
                    'absolute': 37,
                    'relative': 0.025170068027210883,
                    'cases': 37,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.9736842105263158
            },
            'D|E': {
                'source': 'D',
                'target': 'E',
                'frequency': {
                    'absolute': 122,
                    'relative': 0.08299319727891157,
                    'cases': 117,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 539740800000,
                    'min': 539740800000,
                    'max': 539740800000,
                    'mean': 4424104918,
                    'median': 0
                },
                'dependency': 0.991869918699187
            },
            'RR|D': {
                'source': 'RR',
                'target': 'D',
                'frequency': {
                    'absolute': 6,
                    'relative': 0.004081632653061225,
                    'cases': 6,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.8571428571428571
            },
            'X|V': {
                'source': 'X',
                'target': 'V',
                'frequency': {
                    'absolute': 4,
                    'relative': 0.0027210884353741495,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.8
            },
            'YY|YY': {
                'source': 'YY',
                'target': 'YY',
                'frequency': {
                    'absolute': 8,
                    'relative': 0.005442176870748299,
                    'cases': 8,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.8888888888888888
            },
            'WW|J': {
                'source': 'WW',
                'target': 'J',
                'frequency': {
                    'absolute': 88,
                    'relative': 0.05986394557823129,
                    'cases': 88,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 70416000000,
                    'min': 70416000000,
                    'max': 70416000000,
                    'mean': 800181818,
                    'median': 0
                },
                'dependency': 0.7352941176470589
            },
            'WW|M': {
                'source': 'WW',
                'target': 'M',
                'frequency': {
                    'absolute': 125,
                    'relative': 0.08503401360544217,
                    'cases': 125,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 42940800000,
                    'min': 42940800000,
                    'max': 42940800000,
                    'mean': 343526400,
                    'median': 0
                },
                'dependency': 0.5987261146496815
            },
            'U|B': {
                'source': 'U',
                'target': 'B',
                'frequency': {
                    'absolute': 9,
                    'relative': 0.006122448979591836,
                    'cases': 9,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 13305600000,
                    'min': 13305600000,
                    'max': 13305600000,
                    'mean': 1478400000,
                    'median': 0
                },
                'dependency': 0.7272727272727273
            },
            'U|YY': {
                'source': 'U',
                'target': 'YY',
                'frequency': {
                    'absolute': 3,
                    'relative': 0.0020408163265306124,
                    'cases': 3,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.75
            },
            'Y|D': {
                'source': 'Y',
                'target': 'D',
                'frequency': {
                    'absolute': 4,
                    'relative': 0.0027210884353741495,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 29894400000,
                    'min': 29894400000,
                    'max': 29894400000,
                    'mean': 7473600000,
                    'median': 0
                },
                'dependency': 0.8
            },
            'V|WW': {
                'source': 'V',
                'target': 'WW',
                'frequency': {
                    'absolute': 32,
                    'relative': 0.021768707482993196,
                    'cases': 32,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 75772800000,
                    'min': 75772800000,
                    'max': 75772800000,
                    'mean': 2367900000,
                    'median': 0
                },
                'dependency': 0.9696969696969697
            },
            'V|A': {
                'source': 'V',
                'target': 'A',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 4320000000,
                    'min': 4320000000,
                    'max': 4320000000,
                    'mean': 4320000000,
                    'median': 0
                },
                'dependency': 0.5
            },
            'WW|H': {
                'source': 'WW',
                'target': 'H',
                'frequency': {
                    'absolute': 6,
                    'relative': 0.004081632653061225,
                    'cases': 6,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.8571428571428571
            },
            'S|D': {
                'source': 'S',
                'target': 'D',
                'frequency': {
                    'absolute': 28,
                    'relative': 0.01904761904761905,
                    'cases': 28,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 123897600000,
                    'min': 123897600000,
                    'max': 123897600000,
                    'mean': 4424914285,
                    'median': 0
                },
                'dependency': 0.9655172413793104
            },
            'L|D': {
                'source': 'L',
                'target': 'D',
                'frequency': {
                    'absolute': 6,
                    'relative': 0.004081632653061225,
                    'cases': 6,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.8571428571428571
            },
            'OO|D': {
                'source': 'OO',
                'target': 'D',
                'frequency': {
                    'absolute': 3,
                    'relative': 0.0020408163265306124,
                    'cases': 3,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.75
            },
            'E|M': {
                'source': 'E',
                'target': 'M',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': -16416000000,
                    'min': -16416000000,
                    'max': -16416000000,
                    'mean': -16416000000,
                    'median': 0
                },
                'dependency': 0.5
            },
            'H|D': {
                'source': 'H',
                'target': 'D',
                'frequency': {
                    'absolute': 105,
                    'relative': 0.07142857142857142,
                    'cases': 105,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 663033600000,
                    'min': 663033600000,
                    'max': 663033600000,
                    'mean': 6314605714,
                    'median': 0
                },
                'dependency': 0.9905660377358491
            },
            'D|A': {
                'source': 'D',
                'target': 'A',
                'frequency': {
                    'absolute': 3,
                    'relative': 0.0020408163265306124,
                    'cases': 3,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': -345600000,
                    'min': -345600000,
                    'max': -345600000,
                    'mean': -115200000,
                    'median': 0
                },
                'dependency': 0.75
            },
            'A|H': {
                'source': 'A',
                'target': 'H',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'P|D': {
                'source': 'P',
                'target': 'D',
                'frequency': {
                    'absolute': 16,
                    'relative': 0.010884353741496598,
                    'cases': 16,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 25315200000,
                    'min': 25315200000,
                    'max': 25315200000,
                    'mean': 1582200000,
                    'median': 0
                },
                'dependency': 0.9411764705882353
            },
            'V|E': {
                'source': 'V',
                'target': 'E',
                'frequency': {
                    'absolute': 40,
                    'relative': 0.027210884353741496,
                    'cases': 40,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 62035200000,
                    'min': 62035200000,
                    'max': 62035200000,
                    'mean': 1550880000,
                    'median': 0
                },
                'dependency': 0.975609756097561
            },
            'B|YY': {
                'source': 'B',
                'target': 'YY',
                'frequency': {
                    'absolute': 2,
                    'relative': 0.0013605442176870747,
                    'cases': 2,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.6666666666666666
            },
            'YY|WW': {
                'source': 'YY',
                'target': 'WW',
                'frequency': {
                    'absolute': 20,
                    'relative': 0.013605442176870748,
                    'cases': 20,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 48643200000,
                    'min': 48643200000,
                    'max': 48643200000,
                    'mean': 2432160000,
                    'median': 0
                },
                'dependency': 0.9523809523809523
            },
            'H|YY': {
                'source': 'H',
                'target': 'YY',
                'frequency': {
                    'absolute': 21,
                    'relative': 0.014285714285714285,
                    'cases': 21,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 153878400000,
                    'min': 153878400000,
                    'max': 153878400000,
                    'mean': 7327542857,
                    'median': 0
                },
                'dependency': 0.9545454545454546
            },
            'D|O': {
                'source': 'D',
                'target': 'O',
                'frequency': {
                    'absolute': 2,
                    'relative': 0.0013605442176870747,
                    'cases': 2,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 1555200000,
                    'min': 1555200000,
                    'max': 1555200000,
                    'mean': 777600000,
                    'median': 0
                },
                'dependency': 0.6666666666666666
            },
            'H|V': {
                'source': 'H',
                'target': 'V',
                'frequency': {
                    'absolute': 43,
                    'relative': 0.029251700680272108,
                    'cases': 43,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 106185600000,
                    'min': 106185600000,
                    'max': 106185600000,
                    'mean': 2469432558,
                    'median': 0
                },
                'dependency': 0.9772727272727273
            },
            'S|V': {
                'source': 'S',
                'target': 'V',
                'frequency': {
                    'absolute': 2,
                    'relative': 0.0013605442176870747,
                    'cases': 2,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 15552000000,
                    'min': 15552000000,
                    'max': 15552000000,
                    'mean': 7776000000,
                    'median': 0
                },
                'dependency': 0.6666666666666666
            },
            'Q|D': {
                'source': 'Q',
                'target': 'D',
                'frequency': {
                    'absolute': 2,
                    'relative': 0.0013605442176870747,
                    'cases': 2,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.6666666666666666
            },
            'E|WW': {
                'source': 'E',
                'target': 'WW',
                'frequency': {
                    'absolute': 5,
                    'relative': 0.003401360544217687,
                    'cases': 5,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': -127008000000,
                    'min': -127008000000,
                    'max': -127008000000,
                    'mean': -25401600000,
                    'median': 0
                },
                'dependency': 0.8333333333333334
            },
            'D|D': {
                'source': 'D',
                'target': 'D',
                'frequency': {
                    'absolute': 26,
                    'relative': 0.017687074829931974,
                    'cases': 26,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 71539200000,
                    'min': 71539200000,
                    'max': 71539200000,
                    'mean': 2751507692,
                    'median': 0
                },
                'dependency': 0.9629629629629629
            },
            'G|D': {
                'source': 'G',
                'target': 'D',
                'frequency': {
                    'absolute': 23,
                    'relative': 0.015646258503401362,
                    'cases': 23,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.9583333333333334
            },
            'U|V': {
                'source': 'U',
                'target': 'V',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'Y|YY': {
                'source': 'Y',
                'target': 'YY',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'K|D': {
                'source': 'K',
                'target': 'D',
                'frequency': {
                    'absolute': 1,
                    'relative': 0.0006802721088435374,
                    'cases': 1,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 0,
                    'min': 0,
                    'max': 0,
                    'mean': 0,
                    'median': 0
                },
                'dependency': 0.5
            },
            'II|WW': {
                'source': 'II',
                'target': 'WW',
                'frequency': {
                    'absolute': 4,
                    'relative': 0.0027210884353741495,
                    'cases': 4,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': 6307200000,
                    'min': 6307200000,
                    'max': 6307200000,
                    'mean': 1576800000,
                    'median': 0
                },
                'dependency': 0.8
            },
            'J|U': {
                'source': 'J',
                'target': 'U',
                'frequency': {
                    'absolute': 7,
                    'relative': 0.004761904761904762,
                    'cases': 7,
                    'maxRepetition': 0
                },
                'duration': {
                    'total': -9072000000,
                    'min': -9072000000,
                    'max': -9072000000,
                    'mean': -1296000000,
                    'median': 0
                },
                'dependency': 0.5
            }
        }
    },
    'status': 'COMPLETED'
};
